module.exports = __webpack_public_path__ + "static/assets/0816dfdfed40f2f7ace5cf90ad44bebc.png";